var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173051",
    "data-name": "Group 173051",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    transform: "translate(0 1)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text--scale",
    transform: "translate(1.375 4.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11087",
    "data-name": "Path 11087",
    d: "M15.75,5v.75h-2v4.5H13V5.75H11V5Z",
    transform: "translate(-8.75 -5)",
    fill: "#231f20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT);
export default __webpack_public_path__ + "static/media/T.a25e0f7801acdb36d8b385e5faf67e20.svg";
export { ForwardRef as ReactComponent };